import React, { createContext, useContext, useState, useCallback } from "react";
import GlobalLoader from "../components/GlobalLoader";

const NavigationLoadingContext = createContext();

export const useNavigationLoading = () => {
  const context = useContext(NavigationLoadingContext);
  if (!context) {
    throw new Error(
      "useNavigationLoading must be used within a NavigationLoadingProvider"
    );
  }
  return context;
};

export const NavigationLoadingProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [loadingConfig, setLoadingConfig] = useState({
    title: "Loading...",
    subtitle: "Please wait while we process your request",
  });

  const showLoader = useCallback((title, subtitle) => {
    setLoadingConfig({
      title: title || "Loading...",
      subtitle: subtitle || "Please wait while we process your request",
    });
    setIsLoading(true);
  }, []);

  const hideLoader = useCallback(() => {
    setIsLoading(false);
  }, []);

  const navigateWithLoader = useCallback(
    (navigateFunction, title, subtitle) => {
      showLoader(title, subtitle);

      // Add a small delay to show the loader before navigation
      setTimeout(() => {
        navigateFunction();
        // Hide loader after navigation completes
        setTimeout(() => {
          hideLoader();
        }, 500); // Adjust this delay as needed
      }, 100);
    },
    [showLoader, hideLoader]
  );

  const value = {
    isLoading,
    showLoader,
    hideLoader,
    navigateWithLoader,
    loadingConfig,
  };

  return (
    <NavigationLoadingContext.Provider value={value}>
      {children}
      <GlobalLoader
        show={isLoading}
        title={loadingConfig.title}
        subtitle={loadingConfig.subtitle}
        fullScreen={true}
      />
    </NavigationLoadingContext.Provider>
  );
};
